import React from "react";
import styled from "styled-components";
import { setSelectedDay } from "./actions";
import { useDispatch, useSelector } from "react-redux";
import { selectWeekDateStrings } from "./selectors";
interface IDateSelectorProps {
    weekCount: number;
}

interface IDateContainer {
    day: number;
}

const DateContainer = styled.div<IDateContainer>`
    grid-row: 2;
    grid-column: ${props => props.day + 2};
    width: 100%;
    height: 100%;
    background-color: #3f52b5;
    color: white;
    text-align: center;
    padding-top: 8px;
    cursor: pointer;
`;
const StyledSpan = styled.span`
    font-size: 15px;
`;
export const DateSelector = (props: IDateSelectorProps) => {
    const dispatch = useDispatch();
    const dateStrings = useSelector(selectWeekDateStrings);

    return (
        <>
            {new Array(props.weekCount * 7).fill(0).map((e, i) => (
                <DateContainer
                    day={i}
                    key={i}
                    onClick={() => dispatch(setSelectedDay(i))}
                >
                    <StyledSpan>{dateStrings[i]}</StyledSpan>
                </DateContainer>
            ))}
        </>
    );
};
